import React from 'react';
import { Link } from 'react-router-dom';
import cn from '@/utils/cn';
import type { AssignmentRow } from '../useAssignmentRows';
import { linkClass } from '../gradeSyncPath';

// Laid out like the teacher's Assignments table — location over label over items — so the row support
// is told about ("Section 3 isn't syncing") can be found by eye.
const AssignmentCell = ({ row }: { row: AssignmentRow }) => (
  <div className="tw-min-w-[13rem]">
    {row.location != null && <div className="tw-text-sm tw-text-spa-secondary">{row.location}</div>}
    <Link
      className={cn(linkClass, 'tw-font-semibold')}
      to={`../assignments/${row.assignment_id}`}
    >
      {row.label ?? row.assignment_title}
    </Link>
    {row.items.length > 0 && (
      <ul className="tw-m-0 tw-list-none tw-p-0 tw-text-sm tw-text-spa-secondary">
        {row.items.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index}>{item}</li>
        ))}
      </ul>
    )}
    <div className="tw-font-mono tw-text-xs tw-text-spa-tertiary">{row.assignment_id}</div>
  </div>
);

export default AssignmentCell;
